import React, { FC } from 'react';

import { Button } from '../../../../../button';
import { Modal } from '../../../../../modal/modal.component';
import { ModalIds } from '../../../../../../contexts/modals/modals.types';
import { Typography } from '../../../../../../../../../components';
import { capitalize } from 'lodash';
import styles from './success.module.scss';
import { useSuccessData } from './success.hook';

/**
 * Success component
 * @description Exclusively for the WithdrawAccount flow as its Success stage.
 * @link https://www.figma.com/file/16ideRW6XB1s57uA93ppSl/Manager--%7C-File-for-development?type=design&node-id=2305-155299&mode=dev
 *
 * @author Oleksii Medvediev
 * @category Components
 */
const Success: FC = () => {
  const { t, flowData, handleSubmitSuccess } = useSuccessData();

  return (
    <Modal modalId={ModalIds.withdrawAccountSuccess} title={t('modals.withdrawAccount.success.title')}>
      <div className={styles.wrapper}>
        <Typography.Text variant={'bodyText5'}>
          {t('modals.withdrawAccount.success.accountMessage1', { date: flowData?.date })}
          <br />
          <br />
          {t('modals.withdrawAccount.success.accountMessage2', { date: flowData?.date })}
        </Typography.Text>
        <Button size={'large'} type={'button'} variant={'main'} onClick={handleSubmitSuccess}>
          {capitalize(t('modals.withdrawAccount.success.continue'))}
        </Button>
      </div>
    </Modal>
  );
};

export { Success };
